import './app.css'
import { mount } from 'svelte'
import App from './App.svelte'
import '@edu-quizz/shared/lib/axios'

const app = mount(App, {
  target: document.getElementById('app'),
})

export default app
